import clsx from 'clsx'
import { styles } from 'leds'
import React, { ReactNode, useState } from 'react'

import { Accordion } from './Accordion'

export interface AccordionItem {
  label: string | ReactNode
  content: ReactNode
  itemId: string
}

export interface AccordionGroupProps {
  items: AccordionItem[]
  allowMultipleOpen?: boolean
  initialOpenIndex?: number
  accordionClassName?: (index: number) => string
  accordionButtonClassname?: string
}

export const AccordionGroup: React.FC<AccordionGroupProps> = ({
  items,
  allowMultipleOpen,
  initialOpenIndex,
  accordionClassName,
  accordionButtonClassname,
}) => {
  const [openAccordionIndexes, setOpenAccordionIndexes] = useState([initialOpenIndex])

  return (
    <>
      {items.map(({ content, label, itemId: accordionId }, index) => (
        <Accordion
          accordionId={accordionId}
          buttonClassName={accordionButtonClassname}
          className={clsx(
            accordionClassName?.(index),
            styles({
              borderBottomWidth: 1,
              borderColor: 'grey4',
              borderBottomStyle: 'solid',
              overflowY: 'hidden',
            })
          )}
          isOpen={openAccordionIndexes.some((openAccordionI) => openAccordionI === index)}
          key={accordionId}
          label={label}
          onAccordionClick={(isOpen) => {
            if (isOpen) {
              // when it's open and clicked, we need to close it
              setOpenAccordionIndexes((indexes) => indexes.filter((i) => i !== index))
            } else if (allowMultipleOpen) {
              setOpenAccordionIndexes((indexes) => [...indexes, index])
            } else {
              setOpenAccordionIndexes([index])
            }
          }}
        >
          {content}
        </Accordion>
      ))}
    </>
  )
}
